// project-imports
import chartsMaps from './charts-maps';
import formComponents from './forms';
import other from './other';
// import pages from './pages';
import uiComponents from './ui-components';
import tableRoutes from './tables';
import navigation from './navigation';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [navigation, uiComponents, formComponents, tableRoutes, chartsMaps, other]
};

export default menuItems;
